// 调货列表相关API
import request from '../request.js'

// 批量导入
export function batchImportSync(params) {
    return request({
        url: 'imeiTransfer/batchImportSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 列表查询
export function listTransfer(params) {
    return request({
        url: 'imeiTransfer/list.do?',
        method: 'post',
        data: params
    })
} 